import { render, staticRenderFns } from "./FlipValancePanels.vue?vue&type=template&id=b5cc2a80&scoped=true&"
import script from "./FlipValancePanels.vue?vue&type=script&lang=ts&"
export * from "./FlipValancePanels.vue?vue&type=script&lang=ts&"
import style0 from "./FlipValancePanels.vue?vue&type=style&index=0&id=b5cc2a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cc2a80",
  null
  
)

export default component.exports